import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function FeeStructuresPage() {
  return <InstituteCrudPage config={entityConfigs['fee-structures']} />;
}
